























// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// models
import { AssistanceDevice } from '@/models/assistance'

// components
import FormGetFromDevice from './FormGetFromDevice.vue'
import TableListAssistancesDevice from './TableListAssistancesDevice.vue'

@Component({
    name: 'ModalImportAssistanceFromDevice',
    components: {
        FormGetFromDevice,
        TableListAssistancesDevice
    }
})
export default class ModalImportAssistanceFromDevice extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean

    assistancesDevices: AssistanceDevice[] = []
    title = 'Importar Asistencia desde Dispositivos'
    device: number|null = null

    setAssistances (assistances: AssistanceDevice[]) {
        this.assistancesDevices = assistances
    }

    reset () {
        this.$emit('hide')
        this.assistancesDevices = []
        this.device = null
    }
}
